// extracted by mini-css-extract-plugin
export default {"newTable":"myResource_newTable__mY3m+","table":"myResource_table__3fEkq","upload":"myResource_upload__q4MsX"};